import { useEffect, useState, useMemo } from "react";
import { LoginPageHeader } from "../../components/header/login-page-header";
import { LoginPageTopHeading } from "../../components/login-page-top-heading";
import { PropertiesContext } from "../../contexts/propertiesContext";
import { getDashboardProperties } from "../../services/partner-login-service";
import { LoginPageAboutSection } from "../../components/login-page-about-section";
import PartnerWithUs from "../../components/partner-with-us/partner-with-us";
import type { DashboardProperties } from "../../types";

export function LoginPage(): JSX.Element {
  const [isPartnerAdmin, setIsPartnerAdmin] = useState(false);
  const [properties, setProperties] = useState<DashboardProperties | null>(null);
  const [showPartnerWithUs, setShowPartnerWithUs] = useState(false);
  const contextValue = useMemo(() => ({ properties, setProperties }), [properties]);

  const fetchDashboardProperties = async () => {
    try {
      const res = await getDashboardProperties();

      if (res.status && res.data) {
        setProperties(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Check if HubSpot is available
    if ((window as any).hbspt) {
      setShowPartnerWithUs(true);
    }
  }, [(window as any).hbspt]);

  useEffect(() => {
    if (window.location.pathname.indexOf("admin/login") > -1) {
      setIsPartnerAdmin(true);
    }
    fetchDashboardProperties();
  }, []);

  useEffect(() => {
    if (window.location.pathname.indexOf("admin/login") > -1) {
      if (properties?.partnerDomainSetup === "eu" || properties?.partnerDomainSetup === "sg") {
        setIsPartnerAdmin(false);
        window.location.href = "/login";
      } else {
        setIsPartnerAdmin(true);
      }
    }
  }, [properties]);

  return (
    <PropertiesContext.Provider value={contextValue}>
      <LoginPageHeader />
      <LoginPageTopHeading isPartnerAdmin={isPartnerAdmin} />
      <LoginPageAboutSection />
      {showPartnerWithUs && <PartnerWithUs />}
    </PropertiesContext.Provider>
  );
}
